import { render, staticRenderFns } from "./projectOverview.vue?vue&type=template&id=5a56ba3b&scoped=true&"
import script from "./projectOverview.vue?vue&type=script&lang=js&"
export * from "./projectOverview.vue?vue&type=script&lang=js&"
import style0 from "./projectOverview.vue?vue&type=style&index=0&id=5a56ba3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a56ba3b",
  null
  
)

export default component.exports